import { render, staticRenderFns } from "./promo-banner-edit.vue?vue&type=template&id=87a1c52a&scoped=true"
import script from "./promo-banner-edit.vue?vue&type=script&lang=js"
export * from "./promo-banner-edit.vue?vue&type=script&lang=js"
import style0 from "./promo-banner-edit.vue?vue&type=style&index=0&id=87a1c52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a1c52a",
  null
  
)

export default component.exports